/**
 * el-select实现滑动到底触发分页
 */
import Vue from 'vue';

export default () => {
  Vue.directive('loadmore', {
    bind(el, binding) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      // eslint-disable-next-line func-names
      SELECTWRAP_DOM.addEventListener('scroll', function () {
        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (CONDITION) {
          binding.value();
        }
      });
    },
  });

  Vue.directive('LimitInputNumber', (el, binding) => {
    const { isImplement = true, limitNumber = 2 } = binding.value;
    el.oninput = (event) => {
      let val = event.target.value;
      if (isImplement && val) {
        const RegNum = limitNumber === 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${limitNumber}}`;
        val = val.replace(/[^\d.]/g, ''); // 清除"数字"和"."以外的字符
        val = val.replace(/^\./g, ''); // 验证第一个字符是数字
        val = val.replace(/^0[0-9]/g, '0'); // 非小数不能以0开头
        val = val.replace(/\.{2,}/g, '.');// 只保留第一个, 清除多余的
        val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        val = val.match(new RegExp(RegNum, 'g'));
        if (val !== event.target.value) { // 跳出循环
          event.target.value = val;
          event.target.dispatchEvent(new Event('input'));// 调用input事件使vue v-model绑定更新
        }
      }
    };
  });
};
